import api from "@/api";
import Order from "@/types/Order";
import { AxiosResponse } from "axios";

export default async function getOrderDetails(orderId: string): Promise<Order> {
  const response: AxiosResponse<Order> = await api.get(`/api/orders/${orderId}`);

  return response.data;
}
